import React, { useEffect, useState } from 'react';

const ShareSocial: React.FC = () => {
    const [isNavOpen, setNavOpen] = useState(false);
    const [currentUrl, setCurrentUrl] = useState<string>('');
    const [currentTitle, setCurrentTitle] = useState<string>('');

    const toggleNav = () => setNavOpen(!isNavOpen);

    useEffect(() => {
        setCurrentUrl(window.location.href);
        setCurrentTitle(document.title);
    }, []);


    return (
        <div className="contact-block">
            <div
                className={`contact-nav ${isNavOpen ? 'open' : 'closed'}`}
                style={{
                    transform: isNavOpen ? 'translate3d(0%, 0px, 0px)' : 'translate3d(100%, 0px, 0px)',
                    opacity: isNavOpen ? 1 : 0,
                    transition: 'all 500ms ease-in-out',
                }}
            >
                {/* X (Twitter) */}
                <a
                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(currentTitle)}&url=${encodeURIComponent(currentUrl)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon-link w-inline-block"
                >
                    <div className="fa-brands-span"></div>
                </a>

                {/* WhatsApp */}
                <a
                    href={`https://api.whatsapp.com/send?text=${encodeURIComponent(currentTitle)}%20${encodeURIComponent(currentUrl)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon-link w-inline-block"
                >
                    <div className="fa-brands-span"></div>
                </a>

                {/* Facebook */}
                <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon-link w-inline-block"
                >
                    <div className="fa-brands-span"></div>
                </a>

                {/* LinkedIn */}
                <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon-link w-inline-block"
                >
                    <div className="fa-brands-span"></div>
                </a>
            </div>

            <div className="contact-trigger" onClick={toggleNav}>
                <div className="hamburger-wrapper">
                    <div className="fa-solid-span dark"></div>
                </div>
            </div>
        </div>
    );
};

export default ShareSocial;
